import { BasicStatusesTypes } from 'interfaces';
import { User } from 'models/user.model';

export const WORK_MODEL = {
  WORK_FROM_HOME: 'Home',
  WORK_FROM_OFFICE: 'Office',
} as const;

export const VALIDATION_TYPE = {
  CONTAINS_ONE_OF: 'Contains one of',
  MATCHES_ONE_OF: 'Matches one of',
  ONLY_NUMBER: 'Is only numbers',
  ANY_SYMBOLS: 'Is non-empty text',
  ACCEPT_BUTTON: 'Is accept button',
  PREDEFINED_OPTIONS: 'Add predefined option',
} as const;

export const VALIDATION_TOOLTIP_TEXT = {
  CONTAINS_ONE_OF:
    'User needs to enter an answer (any text) that contains at least one of the possible correct answers.',
  MATCHES_ONE_OF:
    'User needs to enter an answer (any text) that exactly matches one of the possible correct answers.',
  ONLY_NUMBER:
    'User needs to enter only numbers (any integers or decimals) as an answer.',
  ANY_SYMBOLS:
    'User needs to enter any text (any symbols or numbers) as an answer.',
  ACCEPT_BUTTON: 'User needs to click/tap on button as a confirmation.',
  PREDEFINED_OPTIONS:
    'A question in which the user is asked to choose one correct answer from the suggested ones',
} as const;

export type WorkModel = keyof typeof WORK_MODEL;

export type ValidationType = keyof typeof VALIDATION_TYPE;
export type ValidationTooltipText = keyof typeof VALIDATION_TOOLTIP_TEXT;
export type FormMode = 'CREATE' | 'VIEW' | 'EDIT';

export type Answers = {
  correctAnswers?: string[];
  incorrectAnswers?: string[];
};

export interface FileType extends File {
  id?: string;
}

export interface Task {
  readonly id: string;
  title: string;
  description: string;
  attachments: FileType[];
  status: BasicStatusesTypes;
  workModels: WorkModel[];
  validator: ValidationType;
  answers?: Answers;
  errorMessage: string;
  successMessage: string;
  comment: string;
  taskGroupId: string | null;
  order: string;
  readonly author: User | null;
  readonly createdAt: string;
  readonly updatedAt: string;
}

export type DraftTask = Omit<Task, 'id' | 'author' | 'createdAt' | 'updatedAt'>;
